export default {
  reviewsList: {
    carouselReviewsCount: 0,
    selectedProduct: null,
    selectedProducts: [],
    data: [],
    numUnpublished: 0,
    loading: false,
    importing: false,
    creditsLeft: 0,
    importQuota: 0,
    progression: [],
    pagination: {
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: 'created_ts',
      totalItems: 0,
      filteredItems: 0,
      rowsPerPageItems: [10, 20, 50],
      starFiltering: null,
      published: true,
      unpublished: true,
      filterBy: {
        source: [],
        status: [],
        stars: [],
        date: [],
        featured: null,
        photos: null,
        datePicker: false,
        reviewId: null,
      },
      search: '',
      averageRating: 0,
    },
  },
  sellerReviews: {
    numUnapproved: 0,
    reviewsTotal: 0,
    ebaySellerReviewsTotal: 0,
    amazonSellerReviewsTotal: 0,
    loading: false,
    importing: false,
    pagination: {
      search: '',
      descending: true,
      page: 1,
      rowsPerPage: 10,
      sortBy: ['created_ts'],
      totalItems: 0,
      rowsPerPageItems: [10, 20, 50],
      approved: null,
      source: null,
      filterBy: 0,
      stars: [],
    },
    items: [],
  },
  moveProductSearch: {
    items: [],
    loading: false,
    query: '',
  },
  productSearch: {
    loading: false,
    product: null,
    query: null,
    items: [],
    selected: [],
    selectedReviews: [],
    selectedIds: [],
    selectedRatings: [],
    show: false,
  },
};
